<template>
  <header class="app-header">
    <i class="iconfont iconfanhui header-img"  @click="goBack"></i>
    <p style="display: inline-flex" id="vConsole">{{ title }}</p>
    <!--<a slot="right">Feedback</a>-->
    <div class="tips">
      <slot name="tips"></slot>
    </div>
  </header>
</template>

<script>
  export default {
    name: 'app-header',
    props: {
      title: {
        type: String,
        default: ''
      },
    },
    data () {
      return {
      }
    },
    computed: {
      // 根据路由map得到标题
      getTitle () {
        const pathMap = new Map([
          ['/overview', '企业费用详情'],
          ['/open', '充值']
        ])
        const path = this.$route.path;
        return pathMap.get(path)
      }
    },
    mounted() {
      window.AlloyLever.config({
        entry: '#vConsole',
      });
    },
    methods: {
      goBack () {
        if(this.$route.name === 'home') {
          this.backToApp();
        } else {
          this.$emit('goback');
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "common/sass/common.scss";

  .app-header {
    position: absolute;
    z-index: 2;
    height: 44px;
    line-height: 44px;
    padding: 5px 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 17px;
    .header-img {
      position: absolute;
      left: 10px;
      line-height: 44px;
      font-size: 22px;
      color: #ff9900;
    }
    background: $primary-color;
    img {
      display: inline-block;
      font-size: 0;
    }
    p {
      height: 44px;
      line-height: 44px;
      color: $black-font-color;
    }
    .tips {
      position: absolute;
      right: 15px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
  }

</style>
